import type { UpdateFlexBuyPaymentGridDataPayload } from '@makemydeal/dr-offer-redux';
import type { FC } from 'react';
import { FlexBuyPaymentGridItemCell } from './FlexBuyPaymentGridItemCell';

type FlexBuyPaymentGridItemsRowsProps = {
    flexBuyPaymentGridData: UpdateFlexBuyPaymentGridDataPayload | null;
    isLoadingGrid?: boolean;
};

export const FlexBuyPaymentGridItemsRows: FC<FlexBuyPaymentGridItemsRowsProps> = ({ flexBuyPaymentGridData, isLoadingGrid }) => {
    return (
        <>
            {flexBuyPaymentGridData?.map((payments, index) => (
                <FlexBuyPaymentGridItemCell
                    key={`${payments.key}-${payments.value}-${index}`}
                    payments={payments}
                    isLoadingGrid={isLoadingGrid}
                    flexBuyDownPayments={flexBuyPaymentGridData.map((payment) => payment.value)}
                    flexBuyPercents={flexBuyPaymentGridData[0].items.map((item) => item.initialPaymentDiscount)}
                    flexBuyTerms={flexBuyPaymentGridData[0].items.map((item) => item.term)}
                    index={index}
                />
            ))}
        </>
    );
};
